import React,{useEffect,useMemo,useState} from 'react';
import { safeGet, safeSet, safeRemove, safeJsonParse, getSafeSession } from '../utils/browserSafe';
import baseURL from '../url';
import moneda from '../moneda';
import './ComboBuilder.css';

const family=['Mamá','Abuela','Hermano','Novia','Familia'];


export default function ComboBuilder(){
 const [open,setOpen]=useState(false);
 const [products,setProducts]=useState([]);
 const [pick,setPick]=useState({});
 const [selectedFamily,setSelectedFamily]=useState('');
 const [hearts,setHearts]=useState([]);
 const [groups,setGroups]=useState([]);

 useEffect(()=>{
 fetch(`${baseURL}/productosGet.php`).then(r=>r.json()).then(d=>{
   const arr=(d.productos||[]).filter(p=>Number(p.activo??1)===1);
   setProducts(arr);
   const cats=[...new Set(arr.map(p=> (p.categoriasNombres?.[0] || p.categoria || 'General')).filter(Boolean))].slice(0,6);
   setGroups(cats.map((name,i)=>({key:'cat'+i,title:name})));
 }).catch(()=>{})
},[]);

const options=(g)=>{
 const byCategory=products.filter(p=>((p.categoriasNombres?.[0]||p.categoria||'').toLowerCase()===String(g.title).toLowerCase()));
 let list=(byCategory.length?byCategory:products).sort((a,b)=>Number(b.salesCount||0)-Number(a.salesCount||0));
 if(list.length<6){ const extra=products.filter(x=>!list.includes(x)).slice(0,6-list.length); list=[...list,...extra];}
 return list.slice(0,6);
};

 const total=useMemo(()=>Object.values(pick).reduce((s,p)=>s+Number(p?.precio||0),0),[pick]);
 const selectFamily=(name)=>{
   setSelectedFamily(selectedFamily===name?'':name);
   const burst=Array.from({length:12}).map((_,i)=>({id:Date.now()+i,left:25+Math.random()*50,delay:Math.random()*0.3}));
   setHearts(burst);
   setTimeout(()=>setHearts([]),1700);
 };
 const add=()=>{
   const selected=Object.values(pick).filter(Boolean);
   if(!selected.length){alert('Selecciona al menos un producto para el combo.');return;}
   const cart=safeJsonParse(safeGet('cart','[]'), []);
   selected.forEach(p=>cart.push({idProducto:Number(p.idProducto),cantidad:1,item:selectedFamily?[`Compra para: ${selectedFamily}`]:[]}));
   safeSet('cart',JSON.stringify(cart));
   window.dispatchEvent(new Event('cartUpdated'));
   setOpen(false);
 };
 return <>
  <button className="comboFab" onClick={()=>setOpen(true)}>🎁 Arma tu combo</button>
  {hearts.map(h=><span key={h.id} className="floatingHeart" style={{left:`${h.left}%`,animationDelay:`${h.delay}s`}}>❤️</span>)}
  {open&&<div className="comboOverlay" onClick={()=>setOpen(false)}>
   <div className="comboModal comboModalPro" onClick={e=>e.stopPropagation()}>
    <button className="comboClose" onClick={()=>setOpen(false)}>×</button>
    <div className="comboHero">
      <span>Mercadito Familiar</span>
      <h2>Arma un combo para alguien especial</h2>
      <p>Selecciona productos por categoría. La sugerencia usa palabras clave del nombre, descripción y categoría del producto, priorizando los más vendidos.</p>
    </div>

    <section className="familyBox">
      <strong>¿Para quién compras hoy?</strong>
      <small>Opcional. Si eliges alguien, lo guardamos como detalle del combo.</small>
      <div className="familyChips">
        {family.map(x=><button type="button" className={selectedFamily===x?'active':''} onClick={()=>selectFamily(x)} key={x}>❤️ {x}</button>)}
      </div>
    </section>

    <div className="comboSteps">
      {groups.map((g,idx)=><section className="comboGroup" key={g.key}>
        <div className="comboGroupTitle"><b>{idx+1}</b><strong>{g.title}</strong><span>{pick[g.key]?'Seleccionado':'Opcional'}</span></div>
        <div className="comboOptions">
          {options(g).map(p=><button type="button" className={pick[g.key]?.idProducto===p.idProducto?'active':''} onClick={()=>setPick({...pick,[g.key]:p})} key={p.idProducto}>
            <img src={p.imagen1||p.imagen2||p.imagen3||p.imagen4} alt={p.titulo}/>
            <span>{p.titulo}</span>
            <b>{moneda} {p.precio} <small>{p.precioModo==='USD'?'USD':'CUP'}</small></b>
          </button>)}
        </div>
      </section>)}
    </div>

    <div className="comboSummary">
      <div>
        <span>Total estimado</span>
        <strong>{moneda} {total.toFixed(2)}</strong>
        {selectedFamily && <small>Para: {selectedFamily}</small>}
      </div>
      <button className="comboAdd" onClick={add}>Agregar combo al carrito</button>
    </div>
   </div>
  </div>}
 </>
}
